// src/Pages/CoreModules/PppArrangements.jsx
// REG-PPP — PPP Arrangement Registry. Cross-cutting (sits above the eight
// statistical modules), so it gets its own top-level page rather than being
// parked inside Planning & Reporting or Infrastructure.
import React from 'react';
import PppArrangementsTab from '../../component/PPP/PppArrangementsTab';

export default function PppArrangements() {
  return (
    <div className="min-h-screen bg-white px-4 py-5 sm:p-6">
      <div className="mb-6 flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
        <div>
          <h1 className="text-xl font-bold text-gray-900 leading-none">PPP Arrangement Registry</h1>
          <p className="text-xs text-gray-400 mt-1.5">
            Cross-cutting registry of the FMLD PPP portfolio — infrastructure and non-infrastructure arrangements alike
          </p>
        </div>
        <span className="text-sm font-semibold text-gray-400 mt-1">Owner: PPP Unit / Special Duties</span>
      </div>

      <PppArrangementsTab />
    </div>
  );
}
